import React, { useContext } from 'react';
import Products from './products';
import { ListerContext } from '../../listerContext';
import { MessagePropertiesContext } from '../../../../contexts/messageProperties';
import styles from '../errorBoundary/errorBoundary.module.pcss';

function ProductsContainer(): React.ReactElement {
  const [formattedMessage] = React.useContext(MessagePropertiesContext);

  const [{ results, rid }] = useContext(ListerContext);
  const title = formattedMessage({
    id: 'rolex.plp.search.noResults.title',
    fallback: 'No results found'
  });
  const description = formattedMessage({
    id: 'rolex.plp.search.noResults.description',
    fallback: 'Please modify your selected criteria or reset all filters'
  });

  const noResultsMarkup = (
    <div className={styles['error-boundary']}>
      <h3 className="rolex-title rolex-title--grid">{title}</h3>
      <p className="rolex-text text-center">{description}</p>
    </div>
  );

  return results.length > 0 ? <Products products={results} rid={rid} /> : noResultsMarkup;
}

export default ProductsContainer;
